var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"common-otcPayIcon",class:_vm.className,on:{"click":_vm.handClick}},[(_vm.payment)?_c('svg-icon',{attrs:{"icon-class":_vm.getIconClassName(_vm.payment)}}):_c('img',{attrs:{"src":_vm.imgUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }